import script from "./FlashCourswareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlashCourswareCard.vue?vue&type=script&lang=ts&setup=true"

import "./FlashCourswareCard.vue?vue&type=style&index=0&id=34379bdc&scoped=true&lang=css"
import "./FlashCourswareCard.vue?vue&type=style&index=1&id=34379bdc&lang=less&scoped=true"
script.__scopeId = "data-v-34379bdc"

export default script